export default "__VITE_ASSET__b4d6d9f7__"